import { initializeApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache, persistentSingleTabManager } from 'firebase/firestore';
import { getAuth, type Auth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAR6FuAeK6XksL0r7LJ0jCJRtS37PpW3XQ",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "cukit-2f7c6.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "cukit-2f7c6",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "cukit-2f7c6.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "590238845061",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:590238845061:web:0b2d1a6938981e28dd01ec",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-NDYJJQGQX2"
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentSingleTabManager({}) })
});

export const storage = getStorage(app);

// Lazy-initialize Firebase Auth to avoid blocking the critical rendering path.
// Auth's iframe.js adds ~5.5s to the critical request chain when loaded eagerly.
// Auth is only needed for admin features, so we defer initialization until first access.
let _auth: Auth | null = null;
export function getFirebaseAuth(): Auth {
  if (!_auth) {
    _auth = getAuth(app);
  }
  return _auth;
}

// Keep backward-compatible export (getter that lazily initializes)
export const auth = new Proxy({} as Auth, {
  get(_target, prop) {
    return (getFirebaseAuth() as any)[prop];
  }
});

export default app;
